import React from "react";
import styled from "styled-components"
import { ReportText } from "../components/Common/SharedStyledComponents";
import { IrisColors } from "../css/IRISColors";

const AuthContainer = ({children}) => {
    return (
        <Container className="container-fluid">
            <div className="row">
                <div className="col-md-1"></div>
                <div className="col-md-7"></div>
                <div className="col-md-3">{children}</div>
                <div className="col-md-1"></div>
            </div>
            <FooterContainer className="row">
                <Footer>
                    <ReportText white bold center>© {new Date().getFullYear()} Institute for Research on Innovation and Science (IRIS). All rights reserved.</ReportText>
                </Footer>
            </FooterContainer>
        </Container>
    );
}

var backgroundImg = require("../images/iris-envision-future.png");

const Container = styled.div`
	display: flex;
	flex-direction: column;
    min-height: 100vh;
    background: #dae4e7 url(${backgroundImg}) no-repeat center center;
    background-size: cover;
`;

const FooterContainer = styled.div`
    margin-top: auto;
`;

const Footer = styled.div`
    height: 35px;
    width: 100%;
    color: #fff;
    background-color: ${IrisColors.grey};
`;

export default AuthContainer;